<aca-page-layout>
  <div class="aca-page-layout-header">
    <h1 class="aca-page-title">{{ 'APP.BROWSE.WORKFLOW.MENU.MY_TASKS.TITLE' | translate }}</h1>
    <aca-toolbar [items]="actions"></aca-toolbar>
  </div>
  <div class="aca-page-layout-content">
    <div class="tasks-main-content">
      <div class="tmc-header">
        <div class="tmc-header-row1">
          <mat-button-toggle-group [(ngModel)]="taskActive" (change)="onFormChange($event)">
            <mat-button-toggle value="active">{{ 'APP.WORKFLOW.GENERAL.ACTIVE' | translate }}</mat-button-toggle>
            <mat-button-toggle value="complete">{{ 'APP.WORKFLOW.GENERAL.COMPLETE' | translate }}</mat-button-toggle>
          </mat-button-toggle-group>
          <mat-icon
          *ngIf="taskActive === 'active'"
          matTooltip="{{ 'APP.WORKFLOW.GENERAL.OPEN_DIALOG' | translate }}"
          matTooltipPosition="above"
          class="open-dialog-icon"
          (click)="openMyTasksDialog()">
            delete
          </mat-icon>

          <span class="tmc-header-row1-right">
            <span class="task-counter">
              {{ 'APP.WORKFLOW.GENERAL.TASK_COUNTER' | translate }} [{{ totalTasksCount }}]
            </span>
            <button mat-button (click)="onSortByDate($event)">
              {{ currentSort === 'date' ? '•' : '' }}
              {{ 'APP.WORKFLOW.GENERAL.DATE_STARTED' | translate }}
              <mat-icon>{{ sortDateAsc ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
            </button>
            <button mat-button (click)="onSortByPriority($event)">
              {{ currentSort === 'priority' ? '•' : '' }}
              {{ 'APP.WORKFLOW.GENERAL.PRIORITY' | translate }}
              <mat-icon>{{ sortPriorityAsc ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
            </button>

            <button mat-raised-button (click)="onToggleShowFilters()">
              <mat-icon>search</mat-icon>
            </button>
          </span>
        </div>
        <div class="tmc-header-row2" [hidden]="!showFilters" (change)="onFilterFormChange($event)">
          <form [formGroup]="filterForm" (keydown.enter)="onFormEnter($event)" novalidate>
            <mat-form-field appearance="standard" id="mff-description">
              <mat-label>{{ 'APP.WORKFLOW.GENERAL.DESCRIPTION' | translate }}</mat-label>
              <input matInput formControlName="description" name="description" type="text" />
            </mat-form-field>
            <mat-form-field appearance="standard" id="mff-priority">
              <mat-label>{{ 'APP.WORKFLOW.GENERAL.PRIORITY' | translate }}</mat-label>
              <mat-select formControlName="priority" (selectionChange)="onFilterFormChange($event)">
                <mat-option *ngFor="let priorityOption of priorityOptions" [value]="priorityOption.id">{{ priorityOption.value }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="standard" id="mff-date-started-from">
              <mat-label>{{ 'APP.WORKFLOW.GENERAL.DATE_STARTED_FROM' | translate }}</mat-label>
              <input matInput [matDatepicker]="dateStartedFromPicker" [max]="today" formControlName="dateStartedFrom" (dateChange)="onFilterFormChange($event)" name="dateStartedFrom" readonly />
              <mat-datepicker-toggle matSuffix [for]="dateStartedFromPicker"></mat-datepicker-toggle>
              <mat-datepicker #dateStartedFromPicker  disabled="false"></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="standard" id="mff-date-started-to">
              <mat-label>{{ 'APP.WORKFLOW.GENERAL.DATE_STARTED_TO' | translate }}</mat-label>
              <input matInput [matDatepicker]="dateStartedToPicker" [max]="today" formControlName="dateStartedTo" (dateChange)="onFilterFormChange($event)" name="dateStartedTo" readonly />
              <mat-datepicker-toggle matSuffix [for]="dateStartedToPicker"></mat-datepicker-toggle>
              <mat-datepicker #dateStartedToPicker disabled="false"></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="standard" id="mff-initiator">
              <mat-label>{{ 'APP.WORKFLOW.GENERAL.INITIATOR' | translate }}</mat-label>
              <input matInput formControlName="initiator" [matAutocomplete]="autocompleteInitiator">
              <mat-autocomplete #autocompleteInitiator="matAutocomplete">
                <mat-option *ngFor="let user of usersFiltered | async" [value]="user.id">
                  {{ user.firstName + (user.lastName ? (' ' + user.lastName) : '') }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <button mat-button (click)="onResetFilters($event)">
              <mat-icon>clear_all</mat-icon>
            </button>
          </form>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="tmc-body">
        <mat-spinner *ngIf="isLoading" [diameter]="60" style="margin: 0 auto;"></mat-spinner>
        <div *ngIf="!isLoading">
          <div *ngIf="tasksPaginated.length === 0">
            {{ 'APP.WORKFLOW.TASK_LIST.NO_ITEMS' | translate }}
          </div>

          <div *ngIf="tasksPaginated.length > 0">
            <div class="tmcb-list">
              <div *ngFor="let task of tasksPaginated; let i = index" class="tmcbl-task" [ngClass]="{'high-priority': task.properties?.bpm_priority == 1}">
                <mat-icon [ngClass]="getTaskIconDetails(task).color" (click)="onClickTask(task.id)">{{ getTaskIconDetails(task).icon }}</mat-icon>
                <div class="tmcblt-data">
                  <div class="tmcbltd-row" (click)="onClickTask(task.id)">{{ task.description }}</div>
                  <div class="tmcbltd-row">
                    <span class="tmcbltdr-pair">
                      <span class="tmcbltdrp-label">{{ 'APP.WORKFLOW.GENERAL.SENT' | translate }}: </span>
                      <span class="tmcbltdrp-value">{{ getTaskSentValue(task) }}</span>
                    </span>
                    <span class="tmcbltdr-pair">
                      <span class="tmcbltdrp-label">{{ 'APP.WORKFLOW.GENERAL.FROM' | translate }}: </span>
                      <span class="tmcbltdrp-value">{{ getTaskFromValue(task) }}</span>
                    </span>
                    <span class="tmcbltdr-pair">
                      <span class="tmcbltdrp-label">{{ 'APP.WORKFLOW.GENERAL.PRIORITY' | translate }}: </span>
                      <span class="tmcbltdrp-value">{{ getTaskPriorityValue(task) }}</span>
                    </span>
                    <span class="tmcbltdr-pair">
                      <span class="tmcbltdrp-label">{{ 'APP.WORKFLOW.GENERAL.TYPE' | translate }}: </span>
                      <span class="tmcbltdrp-value">{{ getTaskTypeValue(task).type }}</span>
                    </span>
                    <span [hidden]="!task['properties']['bpm_dueDate']" class="tmcbltdr-pair">
                      <span class="tmcbltdrp-label">{{ 'APP.WORKFLOW.GENERAL.DUE' | translate }}: </span>
                      <span class="tmcbltdrp-value">{{ getTaskDueValue(task) }}</span>
                    </span>
                  </div>
                </div>
                <mat-icon *ngIf="getTaskIconDetails(task).color === 'circle-red'" (click)="onClickTask(task.id)">{{ getTaskTypeValue(task).icon }}</mat-icon>
              </div>
            </div>
    
            <div class="tmcb-pagination">
              <div class="tmcbp-inner-container">
                <button mat-button [disabled]="currentPage <= 1" (click)="onPreviousPage()">
                  <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
                <mat-form-field appearance="standard" id="pagination-page-input">
                  <input matInput [(ngModel)]="selectedPage" (change)="onJumpToPage()" />
                </mat-form-field>
                <span class="tmcbp-pages-larger-font">/</span>
                <span class="tmcbp-total-pages tmcbp-pages-larger-font">{{ numberOfPages }}</span>
                <button mat-button [disabled]="currentPage >= numberOfPages" (click)="onNextPage()">
                  <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</aca-page-layout>
